import React, { Component } from "react";
import './Share.scss'

let url = window.location;

class Share extends Component {

  render() {

    return (
      <div className="standard-padding" id="shareButtons">
        <div className="content-wrapper container-fluid">
          <div className="row">
            <div className="col-12 text-center">
              <h3>
                Deel dit artikel
              </h3>
            </div>
            <div className="col-12 text-center">
              {/* eslint-disable-next-line react/jsx-no-target-blank */}
              <a target="_blank" href={"http://www.facebook.com/sharer.php?u="+ url}>
                <i className="fab fa-facebook-square"/>
              </a>
              {/* eslint-disable-next-line react/jsx-no-target-blank */}
              <a target="_blank" href={"http://www.linkedin.com/shareArticle?mini=true&url="+ url}>
                <i className="fab fa-linkedin"/>
              </a>
            </div>
          </div>
        </div>
      </div>
    )
  }
}

export default Share;
